export function toSnakeCase(tag) {
  return tag.toLowerCase().split(' ').join('_')
}
